<article class="container">
	<section class="modal-header">
		<p class="title">Adicionar benefício</p>
		<mat-icon
			svgIcon="pm-icons:close"
			style="width: 14px; height: 14px"
			(click)="closeModal()"
		></mat-icon>
	</section>
	<div class="modal-content">
		<form [formGroup]="benefitForm">
			<!-- Description -->
			<div class="form-field">
				<input
					type="text"
					id="description"
					class="form-field__input"
					formControlName="description"
					(focus)="getFieldState('description').setFocused(true)"
					(blur)="getFieldState('description').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('description').focused(),
						filled: benefitForm.controls.description.value,
						editing: getFieldState('description').editing(),
						error:
							benefitForm.controls.description.errors && benefitForm.controls.description.dirty
					}"
				/>
				<label for="description" class="form-field__label">Motivo</label>
				<span class="form-field__underline"></span>
				<div class="error-container">
					@if (
						benefitForm.controls.description.errors?.['required'] &&
						benefitForm.controls.description.dirty
					) {
						<span class="error-message">Motivo é obrigatório</span>
					}
				</div>
			</div>

			<!-- VALUE -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<select
					id="value"
					formControlName="value"
					class="form-field__input"
					(focus)="getFieldState('value').setFocused(true)"
					(blur)="getFieldState('value').setFocused(false)"
					[ngClass]="{
						focused: getFieldState('value').focused(),
						filled: benefitForm.controls.value.value,
						editing: getFieldState('value').editing(),
						error: benefitForm.controls.value.errors && benefitForm.controls.value.dirty
					}"
				>
					<option [ngValue]="300" selected>R$ 300,00</option>
					<option *ngIf="hasCenturionCard()" [ngValue]="1000">R$ 1.000,00</option>
				</select>

				<label for="value" class="form-field__label">Valor</label>
				<span class="form-field__underline"></span>

				<div class="error-container">
					@if (
						benefitForm.controls.value.errors?.['required'] && benefitForm.controls.value.dirty
					) {
						<span class="error-message">Valor é obrigatório</span>
					}
				</div>
			</div>

			<!-- VALID FROM -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<input
					type="text"
					id="validFrom"
					class="form-field__input date_input"
					formControlName="validFrom"
					(focus)="getFieldState('validFrom').setFocused(true)"
					(blur)="getFieldState('validFrom').setFocused(false)"
					[value]="benefitForm.controls.validFrom.value | date: 'dd/MM/yyyy'"
					readonly
					(click)="toggleCalendar('validFrom')"
					[ngClass]="{
						focused: getFieldState('validFrom').focused(),
						filled: benefitForm.controls.validFrom.value,
						editing: getFieldState('validFrom').editing(),
						error: benefitForm.controls.validFrom.errors && benefitForm.controls.validFrom.dirty
					}"
				/>
				<label for="validFrom" class="form-field__label">Data inicial</label>
				<mat-icon
					svgIcon="pm-icons:calendar"
					class="edit-icon"
					*ngIf="calendarField !== 'validFrom'"
					style="--icon-color-red: var(--content-primary)"
				>
					account_circle
				</mat-icon>
				<!-- <span class="form-field__underline"></span> -->
				<div class="error-container">
					@if (
						benefitForm.controls.validFrom.errors?.['required'] &&
						benefitForm.controls.validFrom.dirty
					) {
						<span class="error-message">Telefone é obrigatório</span>
					} @else if (
						benefitForm.controls.validFrom.errors?.['pattern'] &&
						benefitForm.controls.validFrom.dirty
					) {
						<span class="error-message">Telefone deve ter entre 10 e 11 dígitos</span>
					}
				</div>

				<!-- CALENDAR -->
				<div *ngIf="calendarField === 'validFrom'" class="calendar">
					<ui-pm-calendar
						(daySelected)="setDate('validFrom', $event.date)"
						[availabilitiesDates]="availabilityDates"
						[selectedDate]="benefitForm.controls.validFrom.value"
					></ui-pm-calendar>
				</div>
			</div>

			<!-- VALID UNTIL -->
			<div style="height: 24px"></div>
			<div class="form-field">
				<input
					type="text"
					id="validUntil"
					class="form-field__input date_input"
					formControlName="validUntil"
					(focus)="getFieldState('validUntil').setFocused(true)"
					(blur)="getFieldState('validUntil').setFocused(false)"
					(click)="toggleCalendar('validUntil')"
					[value]="benefitForm.controls.validUntil.value | date: 'dd/MM/yyyy'"
					readonly
					[ngClass]="{
						focused: getFieldState('validUntil').focused(),
						filled: benefitForm.controls.validUntil.value,
						editing: getFieldState('validUntil').editing(),
						error: benefitForm.controls.validUntil.errors && benefitForm.controls.validUntil.dirty
					}"
				/>
				<label for="validUntil" class="form-field__label">Data final</label>
				<mat-icon
					svgIcon="pm-icons:calendar"
					class="edit-icon"
					*ngIf="calendarField !== 'validUntil'"
					style="--icon-color-red: var(--content-primary)"
				>
					account_circle
				</mat-icon>
				<!-- <span class="form-field__underline"></span> -->
				<div class="error-container">
					@if (
						benefitForm.controls.validUntil.errors?.['required'] &&
						benefitForm.controls.validUntil.dirty
					) {
						<span class="error-message">Data final é obrigatório</span>
					} @else if (
						benefitForm.controls.validUntil.errors?.['invalidCpf'] &&
						benefitForm.controls.validUntil.dirty
					) {
						<span class="error-message">Data final inválido</span>
					}
				</div>

				<!-- CALENDAR -->
				<div *ngIf="calendarField === 'validUntil'" class="calendar">
					<ui-pm-calendar
						(daySelected)="setDate('validUntil', $event.date)"
						[availabilitiesDates]="availabilityDates"
						[selectedDate]="benefitForm.controls.validUntil.value"
					></ui-pm-calendar>
				</div>
			</div>

			<!-- WARNING -->
			<div class="warning-section">
				<div>
					<p class="title">Atenção:</p>
				</div>

				<ul>
					<li>
						O nome do concierge ficará associado á concessão de benefício para auditoria
						posterior.
					</li>
					<li>
						Certifique-se de que não há reservas/solicitações ativas antes de conceder novo
						benefício.
					</li>
				</ul>
			</div>

			<!-- SAVE BUTTON -->
			<button
				mat-raised-button
				style="margin-bottom: 24px"
				[color]="true ? 'primary' : ''"
				(click)="save()"
			>
				Enviar
			</button>
		</form>
	</div>
</article>
